import { lazy } from 'react';
import withSuspense from '../../helpers/withSuspense.jsx';
import DynamicSkeletonGrid from '../../skeleton_loaders/common/DynamicSkeletonGrid.jsx';

const ValueGrid = withSuspense(lazy(() => import('./ValueGrid.jsx')), DynamicSkeletonGrid);

export default ValueGrid;
